import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectTeacherOnboarding = createSelector(
  [(state: AppState) => state.shared.teacherOnboarding],
  teacherOnboarding => teacherOnboarding,
);
